import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('NewsUserState')
export class NewsUserState {

  @JsonProperty('is_read', Boolean)
  isRead: boolean = false;

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;
}
